import ChemComponent from '../ChemComponent';
import ChemEdit from "../ChemEdit";
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { Chart } from "react-google-charts";

class GracePeriod extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			gp: {
				TYPE_ID: null,
				AFFILIATIONS: null
			},
			graph: [['Grace Period', 'Count']],
			renderKey: 0
		}
	}
		
	onChange(accessor, value) {
		var gp = this.copyObject(this.state.gp);
		this.setByAccessor(gp, accessor, value);
		this.mergeState({ gp: gp });
	}

	onSubmit(event) {
		var self = this;

		this.ajax({
			type: 'POST',
			url: this.getConfig().host + '/Admin/GetGracePeriodHistogram',
			data: {
				roletype: this.state.gp.TYPE_ID,
				affiliation: this.state.gp.AFFILIATIONS
			}
		}).done(function (data) {
			if (data.Success) {
				var graph = [['Grace Period', 'Count']];
				for (var i = 0; i < data.Data.length; i++) {
					graph.push([data.Data[i].CALCULATED_GP_DAYS, data.Data[i].PERSON_COUNT]);
				}
				self.mergeState({ graph: graph });
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	render() {
		return (<>
			<Container fluid>
			  <Row>
			    <Col md={12} lg={11} xl={10} style={{ paddingTop: '20px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Roster</span>
			      <ChemEdit parent={this} columns={gpColumns} data={this.state.gp} user={this.props.user} renderKey={this.state.renderKey}
					onChange={(accessor, value) => this.onChange(accessor, value)} onSubmit={(event) => this.onSubmit(event)}>
				    <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={12}>
					      <Button id="save" variant="warning" type="submit" className="float-end">Create Graph</Button>
						</Col>
					</Form.Group>
				  </ChemEdit>
				</Col>
			  </Row>
			  <Row>
			    <Col>
				  <Chart
					chartType="LineChart"
					data={this.state.graph}
					options={{
					  title: "Grace Period Histogram",
					}}
					legendToggle
				  />
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const gpColumns = [
	{ Header: 'Role Type', accessor: 'TYPE_ID', type: 'select', row: 0, col: 0,
		options: { value: 'TYPE_ID', label: 'TYPE_NAME', entity: 'COLLEGE.ROLE_TYPES', order: 'TYPE_ID' }},
	{ Header: 'Affiliation', accessor: 'AFFILIATIONS', type: 'select', row: 0, col: 1,
		options: { value: 'AFFILIATIONS', label: 'AFFILIATIONS', entity: 'COLLEGE.ROLE_TYPE_GP', order: 'AFFILIATIONS' }}
];

export default GracePeriod;
